import { render, staticRenderFns } from "./ImminentTasks.vue?vue&type=template&id=fe709cf8&"
import script from "./ImminentTasks.vue?vue&type=script&lang=ts&"
export * from "./ImminentTasks.vue?vue&type=script&lang=ts&"
import style0 from "./ImminentTasks.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports